import { getCountry, getLanguage } from '@cemex/cmx-client-layout';
import { createSelector } from '@ngrx/store';
import { getSpecificationForm } from '@ordersnproducts/modules/order-builder/reducers';
import { getRmsSpecificationPage, getRmsUpdatespecifications } from './index';
import { getOpenPlatformProducts } from './products.selectors';

export const getSingleCatalogsState = createSelector(getRmsSpecificationPage, (state) => state.singleCatalogsState);

export const getIsSingleCatalogsLoading = createSelector(getSingleCatalogsState, (state) => state.loading);

export const getApplications = createSelector(getSingleCatalogsState, (state) => state.applications);
export const getApplicationsAndCountryLang = createSelector(
  getSingleCatalogsState,
  getCountry,
  getLanguage,
  (state, country, language) => {
    return { applications: state.applications, country, language };
  },
);

export const getSpacings = createSelector(getSingleCatalogsState, (state) => state.spacings);
export const getLocalSpacings = createSelector(getSingleCatalogsState, (state) =>
  state.spacings.concat(state.localSpacings),
);
export const getFilterSpacings = createSelector(getSingleCatalogsState, (state) => state.filterSpacings);
export const getLocalFilterSpacings = createSelector(getSingleCatalogsState, (state) =>
  state.filterSpacings.concat(state.localSpacings),
);

export const getUnloadTimes = createSelector(getSingleCatalogsState, (state) => state.unloadTimes);
export const getUnloadTimesWithLocalData = createSelector(getSingleCatalogsState, (state) =>
  state.unloadTimes.concat(state.localUnloadTime),
);
export const getFilteredUnloadTimes = createSelector(getSingleCatalogsState, (state) => state.filteredUnloadTimes);

export const getUnloadTypes = createSelector(getSingleCatalogsState, (state) => state.unloadTypes);
export const getUnloadTypesAndCountryLang = createSelector(
  getSingleCatalogsState,
  getCountry,
  getLanguage,
  (state, country, language) => {
    return { unloadTypes: state.unloadTypes, country, language };
  },
);
export const getFilteredUnloadTypes = createSelector(getSingleCatalogsState, (state) => state.filteredUnloadTypes);
export const getFullAndFilterUnloadTypes = createSelector(getSingleCatalogsState, (state) => {
  return { full: state.unloadTypes, filtered: state.filteredUnloadTypes };
});

export const getSlumps = createSelector(getSingleCatalogsState, (state) => state.slumps);

export const getPumpCapacities = createSelector(getSingleCatalogsState, (state) => state.pumpCapacities);
export const getPumpabilities = createSelector(getSingleCatalogsState, (state) => state.pumpabilities);
export const getFilteredPumpabilities = createSelector(getSingleCatalogsState, (state) => state.filteredPumpability);

// Get temperature
export const getTemperatures = createSelector(getSingleCatalogsState, (state) => [
  ...state.temperatures,
  ...state.localTemperatures,
]);

export const getSlumpsAndProducts = createSelector(
  getSingleCatalogsState,
  getOpenPlatformProducts,
  (catalogState, products) => {
    return { slumps: catalogState.filteredSlumps, products };
  },
);

export const getSlumpsProduct = createSelector(getSingleCatalogsState, (state) => state.slumpProduct);
export const getSlumpAndUpdateForm = createSelector(
  getRmsUpdatespecifications,
  getSlumpsProduct,
  (updateForm, stateSlumps) => {
    return {
      updateForm,
      stateSlumps,
    };
  },
);
export const getProfileSlump = createSelector(getSpecificationForm, getSlumpsProduct, (profiles, slumps) => {
  return {
    profiles,
    slumps,
  };
});

export const getLoadSizes = createSelector(getSingleCatalogsState, (state) => state.loadSizes);

export const isLoadSizesLoading = createSelector(getSingleCatalogsState, (state) => state.loading);
